export default {"src":"/_next/static/media/cybernetics_cat_ic.a930d4e1.svg","height":120,"width":120};